import React from 'react';
import './App.scss';
import reactLogo from './reactLogo.png';

class App extends React.Component {

  render() {
    return (<div className="App">
      <header>
        <h1>React Test App</h1>
      </header>
      <div className="AppBody">
        <div className="Card">
          <img src={reactLogo}/>
        </div>
        <div className="Card">
          <button>useless button</button>
          <ul>
            <li>Useless list</li>
            <li>Items</li>
          </ul>
          <table>
            <tr>
              <th>Column1</th>
              <th>Column2</th>
            </tr>
            <tr>
              <td><a href="">Link to Nowhere</a></td>
              <td>Nothing</td>
            </tr>
          </table>
          <h2>H2</h2>
          <h3>H3</h3>
          <h4>H4</h4>
        </div>
      </div>
      
    </div>
    );
  }

 
}

export default App;
